import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import "./contactForm.css";
// ✅ CORRECT — goes up 2 levels to reach src/
import { sendLeadToSellDo } from "../../services/selldo";
import EnquiryForm from "../shared/enquiryForm/enquiryForm";

const ContactForm = ({ type = "normal", onSuccess }) => {
  const location = useLocation();
  const isSangamamPage = location.pathname === "/sangamam";

  const [submitted, setSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    visitDate: "",
    terms: false,
  });

  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (submitted && window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16666240151/lu0cCPPHhMYcEJfJios-",
        value: 1.0,
        currency: "INR",
      });
    }
  }, [submitted]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    setFormData(updatedFormData);
    validateForm(updatedFormData);
  };

  const validateForm = (formData) => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    if (!formData.visitDate.trim()) {
      newErrors.visitDate = "Please select your planned visit date";
    }

    if (!formData.terms) {
      newErrors.terms = "You must agree to the Terms & Conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClick = async (e) => {
    if (!validateForm(formData)) return;

    try {
      await sendLeadToSellDo({
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        city: formData.city,
        visitDate: formData.visitDate,
        source: "Contact Form",
      });

      setShowSuccess(true);
      setSubmitted(true);
      alert(
        "Thank you for showing your interest! Our business team will reach you soon.",
      );

      setFormData({
        name: "",
        email: "",
        mobile: "",
        city: "",
        visitDate: "",
        terms: false,
      });

      if (onSuccess) {
        onSuccess();
      }

      if (type === "normal") {
        setTimeout(() => {
          setShowSuccess(false);
          setSubmitted(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Sell.do submission error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div
      className="container-contactform"
      style={{
        padding: type === "modal" ? "0px" : "60px 20px",
        minHeight: type === "modal" ? "0vh" : "auto",
      }}
    >
      {type === "normal" && (
        <>
          <h5 className="title-h5">Anandham Plots</h5>
          <h1 className="title">Your Dream. Your Plot. Your Choice.</h1>
          <div className="features">
            <span>
              <span className="tick-circle">✔</span> Affordable Rates
            </span>
            <span>
              <span className="tick-circle">✔</span> Amazing Location
            </span>
            <span>
              <span className="tick-circle">✔</span> Ready to Construction
            </span>
            <span>
              <span className="tick-circle">✔</span> Copius Groundwater
            </span>
          </div>
        </>
      )}

      <div className="footer-form-container">
        {type === "normal" && isSangamamPage && (
          <div
            id="sangamam-contact-form"
            data-aos="fade-up"
            className="contact-section-centered"
          >
            <EnquiryForm
              source="Sangamam Footer Form"
              redirectTo="/sangamam-thankyou"
              referrer="https://anandhamplots.com/sangamam"
              campaignName="Anandham_Thiruporur_plots"
            />
          </div>
        )}

        {type === "normal" && !isSangamamPage && (
          <div data-aos="fade-up" className="contact-section-centered">
            <h2 className="heading-bold">Contact Info</h2>
            <div className="contact-info-block">
              <h3>Our Location</h3>
              <p>
                <b>Anandham Plots ,</b> <br />
                Ground Floor , 63/29, Poes Garden, Teynampet, Chennai, Tamil
                Nadu, 600086.
              </p>
            </div>
            <div className="contact-info-block">
              <h3>Quick Contact</h3>
              <p>Email: contact@anadhamplots.com</p>
              <p>Call Us: +91 98845 33533</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactForm;
